var _polygon, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLeniobio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 255.5 62.3",
    style: {
      enableBackground: "new 0 0 255.5 62.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#6f6259",
    points: "84.3,17.2 84.3,41.9 98.7,41.9 98.7,47.1 78.7,47.1 78.7,17.2 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6f6259",
    d: "M117.8,34.1c-0.3-2.7-2.5-4.1-5.4-4.1c-2.8,0-5.1,1.4-5.9,4.1H117.8z M106.4,38.4c0.3,2.6,2.6,4.5,6.2,4.5  c1.9,0,4.4-0.7,5.6-2l3.3,3.3c-2.2,2.3-5.8,3.4-9,3.4c-7.2,0-11.5-4.5-11.5-11.2c0-6.4,4.3-11,11.1-11c7,0,11.4,4.4,10.6,13H106.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6f6259",
    d: "M142.2,47.1v-11c0-3.2-1.7-5.6-5.1-5.6c-3.2,0-5.4,2.7-5.4,5.9v10.8h-5.1V26h4.6l0.3,2.9  c2.1-2.1,4.3-3.2,6.9-3.2c4.9,0,8.9,3.7,8.9,10.3v11H142.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6f6259",
    d: "M152,47.1h5.2V26H152V47.1z M157.7,20.1c0,4.1-6.1,4.1-6.1,0C151.6,16.1,157.7,16.1,157.7,20.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#6f6259",
    d: "M166.1,36.6c0,3.2,1.9,6.2,5.7,6.2s5.7-3,5.7-6.2c0-3.2-2.2-6.2-5.7-6.2C168,30.4,166.1,33.5,166.1,36.6z   M182.7,36.6c0,6.1-4.1,11-10.9,11c-6.8,0-10.9-4.9-10.9-11c0-6,4.2-11,10.8-11C178.4,25.6,182.7,30.6,182.7,36.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#6f6259",
    d: "M191.9,41.9h8.6c2.3,0,5.6-0.8,5.6-3.6c0-2.7-3.3-4.1-5.6-4.1h-8.6V41.9z M191.9,29.2h8.6  c3.5,0,4.7-1.5,4.7-3.2c0-1.4-1.1-3.7-4.7-3.7h-8.6V29.2z M210.7,25.9c0,2.3-1.1,4.5-3.9,5.8c3.5,1.1,4.8,4.8,4.8,6.7  c0,6.7-5,8.8-11.1,8.8h-14.1V17.2h14.1C206.4,17.2,210.7,19.9,210.7,25.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#6f6259",
    d: "M215.8,47.1h5.2V26h-5.2V47.1z M221.4,20.1c0,4.1-6.1,4.1-6.1,0C215.3,16.1,221.4,16.1,221.4,20.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#6f6259",
    d: "M229.8,36.6c0,3.2,1.9,6.2,5.7,6.2s5.7-3,5.7-6.2c0-3.2-2.2-6.2-5.7-6.2C231.8,30.4,229.8,33.5,229.8,36.6z   M246.5,36.6c0,6.1-4.1,11-10.9,11s-10.9-4.9-10.9-11c0-6,4.2-11,10.8-11C242.2,25.6,246.5,30.6,246.5,36.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#6f6259",
    d: "M60.9,27.1c0.2,1.3,0.3,2.7,0.3,4.1c0,2.1-0.2,4.1-0.6,6C48.1,55.5,24.1,36.9,4.6,47.4l0,0  c-2-3.3-3.5-7-4.2-10.9C18.6,26.6,42.1,46.1,60.9,27.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff6545",
    d: "M53.3,10.6c1.9,2.1,3.5,4.6,4.8,7.2c-15.2,19.7-39.2-0.5-57.8,8.3c2.4-14.6,15-25.7,30.2-25.7  c6,0,11.7,1.8,16.4,4.8c-7.9,8.4-23.5,0-33.8,11.1C25.7,14.6,41.7,25,53.3,10.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "b5ada5",
    d: "M54.9,50.7c-5.6,6.8-14.1,11.1-23.6,11.1c-7.6,0-14.5-2.8-19.8-7.3C22.7,48.5,42.9,58.5,54.9,50.7z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#6f6259",
    d: "M251,23c0.6,0,0.9-0.4,0.9-0.8c0-0.4-0.3-0.8-0.9-0.8h-1.3V23H251z M251.5,23.7l1.4,1.6v0.2h-1l-1.4-1.7h-0.8  v1.7h-0.9v-5h2.2c1.2,0,1.8,0.8,1.8,1.6C252.8,22.8,252.3,23.5,251.5,23.7z M254.3,23.1c0-2.2-1.4-3.9-3.7-3.9  c-2.4,0-3.7,1.7-3.8,3.9c0,2.2,1.4,3.9,3.8,3.9C253,27,254.3,25.2,254.3,23.1z M255.3,23.1c0,2.6-1.7,4.8-4.7,4.8  c-3,0-4.7-2.2-4.7-4.8c0-2.6,1.7-4.8,4.7-4.8C253.6,18.3,255.3,20.5,255.3,23.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLeniobio);
export default __webpack_public_path__ + "static/media/logo-leniobio.440d9c631b3143490e816ef93183d0d6.svg";
export { ForwardRef as ReactComponent };